import { Store } from "react-notifications-component";
import * as yup from "yup";
import { FormattedMessage } from "react-intl";
import { ACCESS_TOKEN, BASE_URL, initialPopupState } from "./constants";
import { color } from "framer-motion";

export const getAuthUser = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
        return JSON.parse(token).user;
    } else {
        return false;
    }
}

export const getToken = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
        return JSON.parse(token).access_token;
    } else {
        return false;
    }
}

export const setToken = (access_token) => {
    localStorage.setItem(ACCESS_TOKEN, JSON.stringify(access_token));
}

export const removeToken = () => {
    localStorage.removeItem(ACCESS_TOKEN);
}

export const success_alert = (message, title) => {
    let new_msg = "";
    if ((message[0] === '"' || message[0] === "'") && (message[message.length - 1] === '"' || message[message.length - 1] === "'")) {
        new_msg = message.substr(1, message.length - 2);
    } else {
        new_msg = message
    }
    Store.addNotification({
        title: title ? title : "",
        message: new_msg,
        className: "noti",
        type: "success",
        insert: "bottom",
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__fadeInUp"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
            duration: 7000,
            onScreen: true,
            showIcon: true
        }
    })
}

export const error_alert = (message, title) => {
    let new_msg = "";
    if ((message[0] === '"' || message[0] === "'") && (message[message.length - 1] === '"' || message[message.length - 1] === "'")) {
        new_msg = message.substr(1, message.length - 2);
    } else {
        new_msg = message
    }
    Store.addNotification({
        title: title ? title : "",
        message: new_msg,
        className: "noti",
        type: "danger",
        insert: "bottom",
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__slideInRight"],
        animationOut: ["animate__animated", "animate__slideOutBottom"],
        dismiss: {
            duration: 7000,
            onScreen: true,
            showIcon: true
        }
    })
}

export const warning_alert = (message, title) => {
    Store.addNotification({
        title: title ? title : "",
        message: message,
        type: "warning",
        insert: "bottom",
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
            duration: 7000,
            onScreen: true,
            showIcon: true
        }
    })
}


export function stringNotEmpty() {
    return yup.mixed().test({
        name: 'stringNotEmpty',
        exclusive: false,
        message: <FormattedMessage id="required" defaultMessage="Required" />,
        test: function (value) {
            if (value !== undefined && value !== false) {
                return value.trim() !== "";
            } else if (value === undefined) {
                return false
            }
        },
    });
}

export const selectStyles = error => (
    {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: state.isDisabled ? "#fff" : "#fff",
            borderRadius: "0.375rem",
            border: state.isDisabled ? "2px solid #e4e4e4" : state.isFocused ? "2px solid #242656" :  state.isSelected ? "2px solid #242656" : state.hasValue ? "1px solid #242656": error ? "2px solid #ef4444": "2px solid #cbd5e1",
            "&:hover": {
                border: "2px solid #242656",
                boxShadow: "0px 0px 4px #242656"
            },
            fontSize: "1rem",
            "@media (max-width:1024px)": {
                fontSize: "0.875rem"
            }
            
        }),
        option: (provided, state) => {
            return ({
                ...provided,
                background: state.isSelected ? "#242656" : "white",
                color: state.isSelected ? "#ffffff" : "#500",
                "&:hover": {
                    "background": "#242656",
                    color: "#ffffff"
                },
                fontSize: "1rem",
                "@media (max-width:1024px)": {
                    fontSize: "0.875rem"
                }
            })
        },
        
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';
    
            return { ...provided, opacity, transition };
        }
    }
)
export const selectStylesFilter = error => (
    {
        
        control: (provided, state) => ({
            ...provided,
            // height: "12px",
            fontSize: "12px",
            backgroundColor: state.isDisabled ? "#fff" : "#fff",
            borderRadius: "0.375rem",
            border: state.isDisabled ? "1px solid #e4e4e4" : state.isFocused ? "1px solid #4c0788" :  state.isSelected ? "1px solid #ef4444" : state.hasValue ? "1px solid #4c0788": error ? "1px solid #ef4444": "1px solid #cbd5e1",
            boxShadow: state.isFocused ? "0px 0px 6px #242656" : "none",
        }),
        
        option: (provided, state) => {
            return ({
                ...provided,
                background: state.isSelected ? "#242656" : "white",
                color: state.isSelected ? "#FFFFFF" : "#500",
                fontSize: "12px",
                "&:hover": {
                    "background": "#242656",
                    color: "#FFFFFF"
                },
            })
        },
        
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';
    
            return { ...provided, opacity, transition, fontSize: "12px" };
        }
    }
)


export const hidePopup = (setState) => {
    setState(initialPopupState)
}

export const phoneRegExp = /^((\\+[0-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/


export const isValidURL=(str)=>{
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+:]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
}

export const toCommaSeparated = (arr) =>
    Array.isArray(arr) && arr.length
        ? arr.map(item => item.value).join(",")
        : "";

export const getImage = (value) => {
    return BASE_URL+value.substr(1)
}

export const canvasToBlob=(canvas, callback) =>{
    canvas.toBlob(function(blob) {
      callback(blob);
    }, 'image/png');
}
// export const customStyles = {
//     rows: {
//         style: {
//         minHeight: '72px', // override the row height
//         }
//     },
//     headCells: {
//         style: {
//             "&:hover": {
//                 color:"white"
//             },
//             backgroundColor: "#4c0788",
//             color: "white",
//             padding: "10px 10px",
//             fontWeight: "light",
//             fontSize: "15px",
//             borderRight: "1px solid #ddd",

//             borderLeft: "1px solid #ddd",
//             textAlign: "left"
            
//         },

//         activeSortStyle: {
//             color: "white",
//             '&:focus': {
//                 outline: 'none',
//             },
//             '&:hover:not(:focus)': {
//                 color: "white",
//             },
//         },
//         inactiveSortStyle: {
//             '&:focus': {
//             outline: 'none',
//             color: "white",
//             },
//             '&:hover': {
//                 color: "white",
//             },
//         },
//     },
//     cells: {
//         style: {
//             borderBottom: "1px solid #ddd",
//             borderRight: "1px solid #ddd",
//             borderLeft: "1px solid #ddd",
//             margin: "0",
//             width:"150px"

//         },
//     },
// };
export const customStyles = {
    rows: {
        style: {
        minHeight: '60px', // override the row height
        borderBottom: "0.8px solid #ccc",
        paddingTop:'5px',
        paddingBottom:'5px'
        }
    },
    headCells:{
        style:{
            color:"#4c0788",
            // color:"#40e0d0",
            fontSize:"12px",
            // backgroundColor: "#40e0d0",
            fontWeight: "600",
        }
    },
    cells: {
        style: {
           color: "#000",
           fontWeight: "500",
           minWidth:'120px'
        },
    },
};

export const calculateDiscountPrice=(discountPercentage,totalPrice,discount_amount)=>{
    if(discountPercentage*totalPrice){
        const discountAmount = (totalPrice * discountPercentage) / 100;
        const discountedPrice = totalPrice - discountAmount;

        if(discount_amount){
            return discountAmount<0? 0: discountAmount
        }else{
            return discountedPrice<0 ? 0: discountedPrice
        }

    }else{
        return 0
    }
}

export const isInt=(n)=>{
    return Number(n) === n && n % 1 === 0;
}


// export const howMuchIsOff=(totalPrice,discountPrice,sendWithoutFloating)=>{
export const howMuchIsOff=(totalPrice,discountPrice)=>{
    // if(totalPrice&&discountPrice){
        discountPrice=totalPrice-discountPrice
        let off_value=((totalPrice - discountPrice) / totalPrice) * 100
        
        // return Number.isInteger(off_value)? off_value:parseInt(off_value)
        return off_value
    
    
}

export const formatMoney = (amount) => {
    if (amount >= 1000000) {
      return (amount / 1000000).toFixed(0) + "M";
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(0) + "k";
    } else {
      return amount ? amount.toString():0;
    }
};

export const slugify=( str )=> {
    if(str){
        //replace all special characters | symbols with a space
        str = str.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, ' ')
                 .toLowerCase();
          
        // trim spaces at start and end of string
        str = str.replace(/^\s+|\s+$/gm,'');
          
        // replace space with dash/hyphen
        str = str.replace(/\s+/g, '-');   
    
        return str;
    }else{
        return ""
    }
    
}


export const makeUniqueName =(length=5)=>{
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}


export const updateStorageObj=(fName,lName)=>{
    let tokenObj = localStorage.getItem(ACCESS_TOKEN);
    let parsedTokenObj=JSON.parse(tokenObj)
    parsedTokenObj.user.first_name = fName
    parsedTokenObj.user.last_name = lName
    localStorage.setItem(ACCESS_TOKEN,JSON.stringify(parsedTokenObj));
}



// Convert Base64 to CSV
export const convertBase64ToCSV = (base64Data, filename) => {
    const csvData = atob(base64Data);

    // Create a Blob with the decoded CSV data
    const blob = new Blob([csvData], { type: "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    
    // Create a download link and trigger it
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    
    // Clean up the object URL after download
    URL.revokeObjectURL(link.href);
};
// Convert Base64 to CSV
export const convertBase64ToXLS = (base64Data, filename) => {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    
    URL.revokeObjectURL(link.href);

};





